import { get } from "../../service/api";

const getMerchantInvoiceCountDetail = async (merchantId, merchantInvoiceId) => {
  try {
    const response = await get(
      `/merchant/${merchantId}/merchantInvoice/${merchantInvoiceId}/countDetail`
    );
    return response.data;
  } catch (error) {
    console.error("Error getMerchantInvoiceCountDetail:", error);
    throw error;
  }
};

export default getMerchantInvoiceCountDetail;
